import GiftDashboardContainer from './GiftDashboardContainer';
export default GiftDashboardContainer;
